export default __webpack_public_path__ + "static/network-4@2x-0f364da3bba501dc2bbb02e2f204e313.png";